import React from "react";
import { useRef, useEffect, useState } from "react";
import "./BackToTop.css";

function BackToTop() {
  const ref = useRef(null);
  const [backToTopButton, setBackToTopButton] = useState(null);

  // Amount of pixels to scroll before showing back to top button
  const showButton = 600;
  // let backToTopButton;

  useEffect(() => {
    setBackToTopButton(ref.current);
  }, []);

  // When the user scrolls down on the site, show the button
  window.onscroll = function () {
    scrollFunction();
  };

  // Show button when user scrolls "showButton" amount of pixels
  function scrollFunction() {
    if (backToTopButton) {
      if (
        document.body.scrollTop > showButton ||
        document.documentElement.scrollTop > showButton
      ) {
        (backToTopButton as HTMLElement).className = "backToTop show";
      } else {
        (backToTopButton as HTMLElement).className = "backToTop hide";
      }
    }
  }

  // Scrolls back to the top of the page
  function backToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  return (
    <button
      className="backToTop hide"
      id="backToTop"
      ref={ref}
      onClick={backToTop}
    >
      <span className="arrow"></span>
    </button>
  );
}

export default BackToTop;
